import { render, staticRenderFns } from "./waitDealToDoorService.vue?vue&type=template&id=bef5c798&scoped=true&"
import script from "./waitDealToDoorService.vue?vue&type=script&lang=js&"
export * from "./waitDealToDoorService.vue?vue&type=script&lang=js&"
import style0 from "./waitDealToDoorService.vue?vue&type=style&index=0&id=bef5c798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef5c798",
  null
  
)

export default component.exports